import { Facebook, Star } from "lucide-react";

export default function FacebookBadge({ compact = false }) {
    return (
        <div
            data-testid="facebook-badge"
            className={`inline-flex items-center gap-3 bg-[var(--ns-blue-soft)] text-[var(--ns-blue)] ${
                compact ? "px-3 py-1.5" : "px-5 py-2.5"
            } rounded-full shadow-sm border border-[var(--ns-blue)]/10`}
        >
            <Facebook className="w-4 h-4" />
            <div className="flex items-center gap-1">
                {[...Array(5)].map((_, i) => (
                    <Star
                        key={i}
                        className="w-3.5 h-3.5 fill-[var(--ns-blue)]"
                        strokeWidth={0}
                    />
                ))}
            </div>
            <span
                className={`font-display font-bold ${compact ? "text-xs" : "text-sm"}`}
            >
                100 % anbefalet · 5 anmeldelser
            </span>
        </div>
    );
}
